import {initBrandModel} from '@/app/js/filter/brand-model'

export function initFilter() {
  const filterFormEls = document.querySelectorAll('.js-filter')

  if (!filterFormEls.length) return

  filterFormEls.forEach(filterFormEl => {
    const apiLink = filterFormEl.dataset.apiLink

    initBrandModel(filterFormEl, apiLink)

    const colorEls = document.querySelectorAll('.js-color-input')
    const checkAllColorsEl = document.querySelector('.js-check-all-colors')

    if (!colorEls.length) return

    let checkedColorsCounter = 0
    colorEls.forEach(colorEl => {
      if (colorEl.checked) checkedColorsCounter++

      colorEl.addEventListener('click', () => {
        if (colorEl.checked) {
          checkedColorsCounter--
        } else {
          checkedColorsCounter++
        }

        checkAllColorsEl.checked = checkedColorsCounter === 0
      })
    })

    checkAllColorsEl.addEventListener('click', e => {
      if (!checkAllColorsEl.checked) return e.preventDefault()
      colorEls.forEach(color => color.checked = false)
      checkedColorsCounter = 0
    })

    document.querySelector('.js-filter-reset').addEventListener('click', () => {
      filterFormEl
        .querySelectorAll('input[type="checkbox"]')
        .forEach(checkboxEl => checkboxEl.removeAttribute('checked'))
      filterFormEl
        .querySelectorAll('input[type="text"]')
        .forEach(textEl => textEl.setAttribute('value', ''))
      filterFormEl
        .querySelectorAll('option[selected]')
        .forEach(optionEl => optionEl.removeAttribute('selected'))
      filterFormEl
        .querySelectorAll('select')
        .forEach(selectEl => $(selectEl).val('').trigger('change'))
    })

    if (!filterFormEl.classList.contains('js-ajax-form')) {
      filterFormEl.addEventListener('submit', e => {
        e.preventDefault()

        const formData = new FormData(filterFormEl)
        const xhr = new XMLHttpRequest()
        const url = new URL(apiLink + '/getUrl')
        const pathQuery = getPathQuery(filterFormEl)

        xhr.open('POST', url.toString())
        xhr.send(formData)
        xhr.onload = () => {
          location.assign(filterFormEl.action + pathQuery + xhr.response)
        }
      })
    }
  })
}


function getPathQuery(formEl) {
  const brandsEl = formEl.querySelector('.js-filter-brands')
  const modelsEl = formEl.querySelector('.js-filter-models')

  let path = ''

  if (brandsEl.value && brandsEl.value !== 'empty') {
    path += '&path=0_' + brandsEl.value

    if (modelsEl.value) {
      path += '_' + modelsEl.value

    }
  }

  return path
}
